document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-ir-inside]');
  if (!root) return;

  const track = root.querySelector('[data-ir-inside-track]');
  const items = Array.from(root.querySelectorAll('[data-ir-inside-item]'));
  const imgWrap = root.querySelector('[data-ir-inside-image]');
  const img = imgWrap ? imgWrap.querySelector('img') : null;
  const controls = root.querySelector('[data-ir-inside-controls]');
  const range = controls ? controls.querySelector('[data-ir-inside-range]') : null;
  const prev = root.querySelector('[data-ir-inside-prev]');
  const next = root.querySelector('[data-ir-inside-next]');

  if (!track || !items.length || !imgWrap || !img) return;

  let isUpdatingRange = false;

  // Check if scrolling is needed
  const checkScrollNeeded = () => {
    // Check if all items are fully visible
    const trackRect = track.getBoundingClientRect();
    const allItemsVisible = items.every(item => {
      const itemRect = item.getBoundingClientRect();
      return itemRect.left >= trackRect.left && itemRect.right <= trackRect.right;
    });
    
    // Alternative check: if we have 4 or fewer items, hide controls
    const shouldHideControls = items.length <= 4 || allItemsVisible;
    
    console.log('Debug checkScrollNeeded:', {
      itemsLength: items.length,
      scrollWidth: track.scrollWidth,
      clientWidth: track.clientWidth,
      allItemsVisible,
      shouldHideControls,
      controlsExists: !!controls
    });
    
    if (controls) {
      if (shouldHideControls) {
        controls.style.display = 'none';
        controls.style.visibility = 'hidden';
        console.log('Controls HIDDEN - All items visible or <= 4 items');
      } else {
        controls.style.display = 'flex';
        controls.style.visibility = 'visible';
        console.log('Controls SHOWN - Need scrolling');
      }
    }
    
    return !shouldHideControls;
  };

  const setActive = (btn) => {
    items.forEach((el) => el.classList.toggle('is-active', el === btn));

    const url = btn.getAttribute('data-image') || '';
    const url2x = btn.getAttribute('data-image-2x') || '';
    const alt = btn.getAttribute('data-alt') || '';

    if (!url) return;

    imgWrap.classList.add('is-switching');

    const preload = new Image();
    preload.src = url2x || url;
    preload.onload = () => {
      img.setAttribute('src', url);
      if (url2x) {
        img.setAttribute('srcset', `${url} 1200w, ${url2x} 2000w`);
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('alt', alt);

      requestAnimationFrame(() => {
        imgWrap.classList.remove('is-switching');
      });
    };
  };

  const updateRangeFromScroll = () => {
    if (isUpdatingRange || !range) return;
    
    const maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 0) {
      range.value = 0;
      return;
    }
    
    const scrollPercent = track.scrollLeft / maxScroll;
    range.value = scrollPercent * 1000;
  };

  const scrollFromRange = () => {
    if (!range) return;
    
    isUpdatingRange = true;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const scrollPercent = range.value / 1000;
    track.scrollLeft = scrollPercent * maxScroll;
    
    requestAnimationFrame(() => {
      isUpdatingRange = false;
    });
  };

  const scrollByAmount = () => {
    const first = items[0];
    if (!first) return 220;
    const r = first.getBoundingClientRect();
    return Math.max(180, Math.round(r.width + 52));
  };

  // Item click handlers
  items.forEach((btn) => {
    btn.addEventListener('click', () => setActive(btn));
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setActive(btn);
      }
    });
  });

  // Range input handler
  if (range) {
    range.addEventListener('input', scrollFromRange);
  }

  // Scroll event handler
  track.addEventListener('scroll', updateRangeFromScroll);

  // Navigation button handlers
  if (prev) {
    prev.addEventListener('click', () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll > 0) {
        track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
      }
    });
  }

  if (next) {
    next.addEventListener('click', () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll > 0) {
        track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
      }
    });
  }
});

